import { Context } from '../../../index';
import { useContext } from "react"
import { AddIcon } from "../../Other/Icons"

function BonusElement({top,amount,bottom, additionalClass, bonusClick}:any) {
    const BonusBottom = () => {
        return <div className={`bonus_bottom ${additionalClass === 'donate' ? 'button':''}`} onClick={e => additionalClass === 'donate' ? bonusClick(amount) : undefined}>
            <AddIcon />
            {bottom}%
        </div>  
    }
    return (
        <div className='banner_bonusElement'>
             <div className="bonus_top">{top}</div>       
             <div className="bonus_middle">
                <div className="bonus_svg">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-3 0 28 28"><path d="M21.415 12.554 2.418.311C1.291-.296 0-.233 0 1.946v24.108c0 1.992 1.385 2.306 2.418 1.635l18.997-12.243a2.076 2.076 0 0 0 0-2.892" fill="#c8c8c8" fillRule="evenodd"/></svg>                </div>
                {new Intl.NumberFormat('ru-RU').format(amount)}
             </div>
             <BonusBottom />    
        </div>
    )
}

function Bonuses({ additionalClass, bonusClick }:any) {
    const {store} = useContext(Context)
    const {depositBonuses} = store

    return (
        <div className={`banner_bonuses ${additionalClass || ''}`}>
            {
                depositBonuses?.map((el:any) => (
                    <BonusElement top={'RUB'} amount={el.amount} bottom={el.bonus} additionalClass={additionalClass} bonusClick={bonusClick} key={el.id}/>
                ))
            }
        </div>
    )
}

export default Bonuses;